/**
 * Booking Store
 * ----------------------------
 *
 */
export const useBookingStore = defineStore('booking', () => {
    /**
     * Vouchers
     * ------------------------------------------------------------------------------------------
     */
    const voucherCode = ref<VoucherCode>({ voucherCode: '' });

    /**
     * Other
     * ------------------------------------------------------------------------------------------
     */
    const acceptedTermsAndConditions = ref<AcceptedTermsAndConditions>({ });
    const bookingOrigin = ref<Record<string, string>>({ });

    /**
     * ------------------------------------------------------------------------------------------
     */

    function reset() {
        acceptedTermsAndConditions.value = {};
        voucherCode.value = { voucherCode: '' };
        bookingOrigin.value = {};
    }

    return {
        voucherCode,
        acceptedTermsAndConditions,
        bookingOrigin,

        reset,
    };
}, {

    persist: {
        ...storePersist.storePersistOptions,
        key: 'booking-v7',
    },
});
